import Analytics from '@opencare/analytics';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';

import { PageTransition } from 'pages/common/components/PageTransition/PageTransition';
import { useAnalyticsService } from 'services/AnalyticsService';

import { useFunnelStorage } from '../../../funnel/storage/Storage';
import {
  CONCIERGE_KEY,
  generateSafeUrl,
  generateStepAnalytics,
} from '../../utils';

import { CHOICES, SUB_ROUTES } from './constants';
import Parent from './Parent';
import Treatment from './substeps/Treatment/Treatment';
import Urgent from './substeps/Urgent/Urgent';

const analytics = new Analytics();

const Reason = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();
  const history = useHistory();
  const location = useLocation();
  const { url } = useRouteMatch();

  const analyticsService = useAnalyticsService();

  const safeUrl = generateSafeUrl(url);

  useEffect(() => {
    if (storage.loading) {
      return;
    }

    const previousSelection = storage.get(CONCIERGE_KEY.REASON);
    const userUsedBrowserButtons = history.action === 'POP';

    if (!previousSelection || userUsedBrowserButtons) {
      analytics.trackPageView({
        pageType: analytics.pageTypes.CONCIERGE,
        pageName: 'concierge_reason',
        ...generateStepAnalytics(position, storage),
        ...analyticsService.analyticsData,
      });
    } else {
      setSubStep(previousSelection.reasonId);
    }
  }, [storage.loading]);

  const setSubStep = (subStep) => {
    const subRoute = SUB_ROUTES[subStep];

    if (subRoute) {
      history.push(`${safeUrl}${subRoute.path}/`);
    }
  };

  return (
    <PageTransition id={location.pathname.split('/')[3]}>
      <Switch location={location}>
        <Route path={`${safeUrl}${SUB_ROUTES[CHOICES.SPECIFIC_TREATMENT].path}`}>
          <Treatment position={position} moveToNextStep={moveToNextStep} />
        </Route>

        <Route path={`${safeUrl}${SUB_ROUTES[CHOICES.URGENT_ISSUE].path}`}>
          <Urgent position={position} moveToNextStep={moveToNextStep} />
        </Route>

        <Route path={safeUrl}>
          <Parent
            position={position}
            moveToNextStep={moveToNextStep}
            setSubStep={setSubStep}
          />
        </Route>
      </Switch>
    </PageTransition>
  );
};

Reason.defaultProps = {
  position: '',
};

Reason.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default Reason;
